import moment from "moment";
import { BEGIN_TIME_STRING, END_TIME_STRING, type Range } from "../../../utils";

export const TEMPORAL_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const formatDate = (datetime: string): string => {
  if (datetime === BEGIN_TIME_STRING) return "Beginning of Time";
  if (datetime === END_TIME_STRING) return "End of Time";
  let givenTimezoneOffset = moment.parseZone(datetime).utcOffset()
  let dt;
  if (givenTimezoneOffset !== 0) {
    dt = moment(datetime).utcOffset(givenTimezoneOffset)
  }
  else {
    // big problem: we do not know whether timezone has not been given or it is +00:00
    // if its utc time is the same with itself, it means timezone has been given
    let u = moment(datetime).utc().format('YYYY-MM-DD HH:mm:ss')
    // @ts-ignore
    let t = moment(datetime).parseZone(datetime).format('YYYY-MM-DD HH:mm:ss')
    if (u === t) {
      dt = moment(datetime).utc()
    }
    else {
      dt = moment(datetime)
    }
  }

  if (!dt.isSame(moment(dt).startOf('day'))) return dt.format('YYYY-MM-DD HH:mm:ss');
  else return dt.format('YYYY-MM-DD');
};

export const normalizeRanges = (rs: Range[]): typeof rs => {
  const result: Range[] = [];
  for (let i = 0; i < rs.length; i++) {
    const range = rs[i];
    const v: any = range.v as any;
    if (v && typeof v === "object" && typeof v.increment === "string") {
      const offset = v.offset || 0;
      const start = new Date(range.r.start);
      const end = new Date(range.r.end);
      const add = (d: Date, unit: "days" | "months" | "years", inc: number) => {
        const x = new Date(d);
        if (unit === "days") x.setUTCDate(x.getUTCDate() + inc);
        else if (unit === "months") x.setUTCMonth(x.getUTCMonth() + inc);
        else x.setUTCFullYear(x.getUTCFullYear() + inc);
        return x;
      };
      let idx = 0;
      for (let cur = new Date(start); add(cur, v.increment, 0) < end; cur = add(cur, v.increment, 1)) {
        const next = add(cur, v.increment, 1);
        result.push({
          v: offset + idx,
          r: { start: cur.toISOString(), end: next.toISOString() },
        });
        idx++;
      }
    } else {
      result.push(range);
    }
  }
  if (result.length > 0) {
    if (result[0].r.start !== BEGIN_TIME_STRING) {
      result.unshift({ v: result[0].v, r: { start: BEGIN_TIME_STRING, end: result[0].r.start } });
    }
    const last = result[result.length - 1];
    if (last.r.end !== END_TIME_STRING) {
      result.push({ v: last.v, r: { start: last.r.end, end: END_TIME_STRING } });
    }
  }
  return result;
};
